<template>
  <pt-doctor-form class="pt-doctor-form__page" :isEdit="is_edit"></pt-doctor-form>
</template>

<script>
import PtDoctorForm from 'cps/hospital-and-doctor-manage/pt-doctor-manage/pt-doctor-form'
export default {
  name: 'pt-doctor-form__view',
  components: {
    'pt-doctor-form': PtDoctorForm
  },
  props: {
    isEdit: {
      type: String,
      default: ''
    },
    userLogin: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  }
}
</script>
